import { OrderItem } from '@/data/types/Order';
import { useOrderItemList, useOrderItemListRows } from './OrderItemList';

interface BasicCheckOutArgs {
	orderItem: OrderItem[];
	orderId: string;
}

export const useBasicCheckOut = ({ orderItem, orderId }: BasicCheckOutArgs) => {
	const orderItemList = useOrderItemList(orderItem, orderId);
	const orderItemListRows = useOrderItemListRows(orderItemList.data);

	const orderItemListRowsSorted = orderItemListRows.data.sort((a, b) => {
		const nameA = a.details.name || '';
		const nameB = b.details.name || '';
		return nameA.localeCompare(nameB);
	});

	return {
		orderItemList,
		orderItemListRows,
		orderItemListRowsSorted,
		loadingOrderItemListRows: orderItemListRows.loading,
	};
};
